import React from "react";
import EurocrossLogo from "../assets/eurocross_logo_tagline.svg";
import {useNavigate} from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  return (
    <div className="header">
      <img onClick={() => navigate("/")} className="header_brand_logo" src={EurocrossLogo} alt="Eurocross" />
    </div>
  );
};

export default Header;
